export const RESET_STATE = "RESET_STATE";
export const SET_STATUS = "SET_STATUS";
export const SET_PHONE_NUMBER = "SET_PHONE_NUMBER";
export const SET_STRATEGY_PHONE = "SET_STRATEGY_PHONE";
export const SET_CALL_FINISH = "SET_CALL_FINISH";
export const SET_CALL_MUTED = "SET_CALL_MUTED";
export const SET_CALL_HOLD = "SET_CALL_HOLD";
